import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const data = [
  { name: 'wk1', green: 10000, orange: 6000 },
  { name: 'wk2', green: 9000, orange: 5000 },
  { name: 'wk3', green: 15000, orange: 11000 },
  { name: 'wk4', green: 5000, orange: 10000 },
];

const GrowthBoard = () => {
  return (
    <div className="mb-4">
      <h6 className="fw-bold mb-3">Growth Board</h6>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data}>
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="green" fill="#4CAF50" />
          <Bar dataKey="orange" fill="#FF9800" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default GrowthBoard;
